// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-table {
    width: 100%;
}
  
.list-group-item {
    padding: 1rem 1rem;
    border: 2.5px solid #f09502;
    margin-top: 15px;
    border-radius: 8px;
    color: white;
    background: transparent;
    transition: all 0.3s ease;
}

.list-group-item:hover {
    background: rgba(240, 149, 2, 0.1);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.column-tittle {
    color: white !important;
}

.column-tittle div {
    color: white !important;
}

/* Estilos para filtros */
.card {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(240, 149, 2, 0.3);
    border-radius: 12px;
}

.card-header {
    background: rgba(240, 149, 2, 0.2);
    border-bottom: 1px solid rgba(240, 149, 2, 0.3);
    color: white;
}

.form-control, .form-select {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(240, 149, 2, 0.3);
    color: white;
    border-radius: 8px;
}

/* Estilos específicos para las opciones del select */
.form-select option {
    background-color: #2c2c2c !important;
    color: white !important;
    padding: 8px 12px;
}

.form-select option:hover {
    background-color: #f09502 !important;
    color: white !important;
}

.form-select option:checked {
    background-color: #f09502 !important;
    color: white !important;
}

/* Estilos para el dropdown cuando está abierto */
.form-select:focus {
    background: rgba(255, 255, 255, 0.15);
    border-color: #f09502;
    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);
    color: white;
}

/* Estilos adicionales para compatibilidad con navegadores */
.form-select option:not(:checked) {
    background-color: #2c2c2c !important;
    color: white !important;
}

/* Estilos para el contenedor del dropdown */
.form-select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
}

/* Estilos para navegadores WebKit (Chrome, Safari, Edge) */
.form-select::-webkit-list-button {
    background-color: #2c2c2c;
    color: white;
}

/* Estilos para Firefox */
.form-select option {
    background-color: #2c2c2c !important;
    color: white !important;
    border: none;
}

/* Estilos para el hover en las opciones */
.form-select option:hover,
.form-select option:focus {
    background-color: #f09502 !important;
    color: white !important;
}

.form-control:focus, .form-select:focus {
    background: rgba(255, 255, 255, 0.15);
    border-color: #f09502;
    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);
    color: white;
}

.form-control::placeholder {
    color: rgba(255, 255, 255, 0.6);
}

.form-label {
    color: white;
    font-weight: 500;
    margin-bottom: 0.5rem;
}

/* Estilos para encabezados ordenables */
.sortable-header {
    cursor: pointer;
    transition: color 0.3s ease;
    display: inline-flex;
    align-items: center;
    -webkit-user-select: none;
            user-select: none;
}

.sortable-header:hover {
    color: #f09502 !important;
}

.sortable-header i {
    transition: transform 0.3s ease;
}

.sortable-header:hover i {
    transform: scale(1.1);
}

/* Estilos para badges */
.badge {
    font-size: 0.75rem;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
}

.badge.bg-primary {
    background-color: #f09502 !important;
}

.badge.bg-success {
    background-color: #28a745 !important;
}

.badge.bg-danger {
    background-color: #dc3545 !important;
}

.badge.bg-warning {
    background-color: #ffc107 !important;
    color: #000;
}

/* Estilos para botones */
.btn-sm {
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    border-radius: 6px;
    font-weight: 500;
}

.btn-success {
    background-color: #28a745;
    border-color: #28a745;
}

.btn-success:hover {
    background-color: #218838;
    border-color: #1e7e34;
}

.btn-danger {
    background-color: #dc3545;
    border-color: #dc3545;
}

.btn-danger:hover {
    background-color: #c82333;
    border-color: #bd2130;
}

.btn-outline-secondary {
    color: #f09502;
    border-color: #f09502;
}

.btn-outline-secondary:hover {
    background-color: #f09502;
    border-color: #f09502;
    color: white;
}

.btn-outline-primary {
    color: #f09502;
    border-color: #f09502;
}

.btn-outline-primary:hover {
    background-color: #f09502;
    border-color: #f09502;
    color: white;
}

/* Estilos para alertas */
.alert-info {
    background-color: rgba(23, 162, 184, 0.2);
    border-color: rgba(23, 162, 184, 0.3);
    color: white;
}

/* Estilos para estado vacío */
.empty-state {
    padding: 3rem 2rem;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.05);
    border: 2px dashed rgba(240, 149, 2, 0.3);
}

.empty-state i {
    color: #f09502 !important;
}

.empty-state-icon {
    font-size: 3rem !important;
    color: #ccc !important;
}

.empty-state h4 {
    color: white !important;
}

.empty-state p {
    color: rgba(255, 255, 255, 0.7) !important;
}

/* Iconos */
.bi {
    font-size: 1rem;
}

.domo-color {
    color: #f09502;
}

/* Estilos para fechas en desktop */
.col-2 small {
    color: white !important;
    font-weight: 500;
}

.col-2 .bi {
    color: #f09502;
    margin-right: 0.25rem;
}

/* Espaciado general para pantallas medianas */
@media (max-width: 1200px) and (min-width: 1025px) {
    .list-group-item {
        padding-left: 1.25rem;
        padding-right: 1.25rem;
    }
}

/* Layout tablets (iPad) - Vista horizontal de desktop pero con más espaciado */
@media (max-width: 1024px) and (min-width: 769px) {
    .list-group-item {
        padding-left: 2rem;
        padding-right: 2rem;
    }
    
    .list-group-item .row .col-3,
    .list-group-item .row .col-2 {
        padding-left: 1rem;
        padding-right: 1rem;
    }
    
    /* Hacer botones un poco más grandes en tablet */
    .btn-sm {
        padding: 0.6rem 1.25rem;
        font-size: 0.9rem;
    }
}

/* Layout móvil mejorado */
@media (max-width: 768px) {
    .list-group-item {
        padding: 1.25rem 0.5rem;
        margin-bottom: 1rem;
    }
    
    .list-group-item .row {
        display: flex;
        flex-direction: column;
        gap: 0;
    }
    
    /* Reorganizar layout para móvil */
    .list-group-item .col-3,
    .list-group-item .col-2 {
        width: 100% !important;
        max-width: 100% !important;
        flex: 0 0 100% !important;
        margin-bottom: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.75rem 1.5rem;
        border-bottom: 1px solid rgba(240, 149, 2, 0.15);
        min-height: 50px;
    }
    
    .list-group-item .col-3:last-child,
    .list-group-item .col-2:last-child {
        border-bottom: none;
    }
    
    /* Estructura común para todos los campos */
    .list-group-item .col-3,
    .list-group-item .col-2 {
        position: relative;
    }
    
    .list-group-item .col-3::before,
    .list-group-item .col-2::before {
        display: inline-block;
        width: 30px;
        text-align: center;
        font-size: 1.1rem;
        margin-right: 0.75rem;
    }
    
    /* Email en móvil */
    .list-group-item .col-3:first-child {
        font-weight: 600;
        font-size: 1rem;
        padding-top: 0;
    }
    
    .list-group-item .col-3:first-child::before {
        content: "📧";
    }
    
    .list-group-item .col-3:first-child .text-truncate {
        flex: 1;
        text-align: left;
    }
    
    /* Monto en móvil */
    .list-group-item .col-2:nth-child(2) {
        align-items: center;
    }
    
    .list-group-item .col-2:nth-child(2)::before {
        content: "💰";
    }
    
    .list-group-item .col-2:nth-child(2) .badge {
        margin-left: auto;
    }
    
    /* Fecha en móvil */
    .list-group-item .col-2:nth-child(3) {
        align-items: center;
    }
    
    .list-group-item .col-2:nth-child(3)::before {
        content: "📅";
    }
    
    .list-group-item .col-2:nth-child(3) small {
        margin-left: auto;
        font-size: 0.9rem !important;
        font-weight: 500 !important;
    }
    
    /* Estado en móvil */
    .list-group-item .col-2:nth-child(4) {
        align-items: center;
    }
    
    .list-group-item .col-2:nth-child(4)::before {
        content: "🏷️";
    }
    
    .list-group-item .col-2:nth-child(4) .badge {
        margin-left: auto;
    }
    
    /* Acciones en móvil */
    .list-group-item .col-3:last-child {
        justify-content: center;
        padding: 1rem 1.5rem 0 1.5rem;
        border-top: 1px solid rgba(240, 149, 2, 0.25);
        border-bottom: none;
        margin-top: 0.5rem;
    }
    
    .list-group-item .col-3:last-child::before {
        display: none;
    }
    
    /* Headers ocultos en móvil */
    .column-tittle {
        display: none !important;
    }
    
    /* Badges mejorados en móvil */
    .badge {
        font-size: 0.8rem !important;
        padding: 0.5rem 0.75rem !important;
        font-weight: 600 !important;
        border-radius: 6px !important;
        min-width: 80px;
        text-align: center;
    }
    
    /* Botones mejorados en móvil */
    .btn-sm {
        padding: 0.75rem 1.25rem;
        font-size: 0.9rem;
        margin: 0 0.375rem;
        min-width: 120px;
        font-weight: 600;
        border-radius: 8px;
        transition: all 0.3s ease;
    }
    
    /* Flex para botones */
    .d-flex.gap-2 {
        gap: 0.75rem !important;
        justify-content: center;
        flex-wrap: wrap;
        padding-top: 0.5rem;
    }
    
    /* Iconos en elementos móvil */
    .col-2 .bi {
        display: none; /* Ocultar iconos bootstrap ya que usamos emojis */
    }
    
    /* Texto mejorado en móvil */
    .col-2 small {
        color: white !important;
        font-size: 0.9rem !important;
        font-weight: 500 !important;
        line-height: 1.2;
    }
    
    /* Espaciado del email en móvil */
    .list-group-item .col-3:first-child {
        border-bottom: 1px solid rgba(240, 149, 2, 0.2) !important;
    }
    
    /* Hover effects para botones en móvil */
    .btn-sm:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
}

/* Animaciones */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.list-group-item {
    animation: fadeIn 0.3s ease-out;
}

/* Estilos para texto truncado */
.text-truncate {
    max-width: 200px;
}

/* Mejoras de accesibilidad */
.btn:focus {
    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.5);
}

.form-control:focus,
.form-select:focus {
    outline: none;
}

/* Estilos para el contador de resultados */
.alert {
    border-radius: 8px;
    margin-bottom: 1.5rem;
}

/* Para dispositivos muy pequeños */
@media (max-width: 480px) {
    .list-group-item {
        padding: 1rem 0.75rem;
        margin: 0.75rem 0;
    }
    
    .list-group-item .col-3,
    .list-group-item .col-2 {
        padding: 0.75rem 1.75rem !important;
    }
    
    .list-group-item .col-3:last-child {
        padding: 1rem 1.75rem 0 1.75rem !important;
    }
    
    .list-group-item .col-3::before,
    .list-group-item .col-2::before {
        width: 25px;
        font-size: 1rem;
        margin-right: 0.5rem;
    }
    
    .btn-sm {
        padding: 0.65rem 1rem;
        font-size: 0.85rem;
        min-width: 110px;
    }
    
    .badge {
        font-size: 0.75rem !important;
        padding: 0.4rem 0.6rem !important;
        min-width: 70px;
    }
    
    /* Panel de filtros más compacto */
    .card-body {
        padding: 1rem 0.75rem;
    }
    
    .card-body .row.g-3 {
        gap: 1rem;
    }
    
    .card-body .col-md-3,
    .card-body .col-md-6 {
        margin-bottom: 0.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/withdrawal-requests/withdrawal-requests.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,yBAAyB;AACzB;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,+CAA+C;IAC/C,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,wCAAwC;IACxC,YAAY;IACZ,kBAAkB;AACtB;;AAEA,qDAAqD;AACrD;IACI,oCAAoC;IACpC,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA,iDAAiD;AACjD;IACI,qCAAqC;IACrC,qBAAqB;IACrB,gDAAgD;IAChD,YAAY;AAChB;;AAEA,4DAA4D;AAC5D;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA,4CAA4C;AAC5C;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA,2DAA2D;AAC3D;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,oCAAoC;IACpC,uBAAuB;IACvB,YAAY;AAChB;;AAEA,0CAA0C;AAC1C;;IAEI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IACrB,gDAAgD;IAChD,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,wCAAwC;AACxC;IACI,eAAe;IACf,2BAA2B;IAC3B,oBAAoB;IACpB,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,yCAAyC;IACzC,qCAAqC;IACrC,YAAY;AAChB;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;IACrC,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA,WAAW;AACX;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA,8CAA8C;AAC9C;IACI;QACI,qBAAqB;QACrB,sBAAsB;IAC1B;AACJ;;AAEA,+EAA+E;AAC/E;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;;QAEI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA,gDAAgD;IAChD;QACI,uBAAuB;QACvB,iBAAiB;IACrB;AACJ;;AAEA,0BAA0B;AAC1B;IACI;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,MAAM;IACV;;IAEA,kCAAkC;IAClC;;QAEI,sBAAsB;QACtB,0BAA0B;QAC1B,yBAAyB;QACzB,gBAAgB;QAChB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,uBAAuB;QACvB,gDAAgD;QAChD,gBAAgB;IACpB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA,2CAA2C;IAC3C;;QAEI,kBAAkB;IACtB;;IAEA;;QAEI,qBAAqB;QACrB,WAAW;QACX,kBAAkB;QAClB,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA,mBAAmB;IACnB;QACI,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,OAAO;QACP,gBAAgB;IACpB;;IAEA,mBAAmB;IACnB;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA,mBAAmB;IACnB;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA,oBAAoB;IACpB;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA,sBAAsB;IACtB;QACI,uBAAuB;QACvB,6BAA6B;QAC7B,6CAA6C;QAC7C,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA,6BAA6B;IAC7B;QACI,wBAAwB;IAC5B;;IAEA,8BAA8B;IAC9B;QACI,4BAA4B;QAC5B,kCAAkC;QAClC,2BAA2B;QAC3B,6BAA6B;QAC7B,eAAe;QACf,kBAAkB;IACtB;;IAEA,+BAA+B;IAC/B;QACI,wBAAwB;QACxB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA,sBAAsB;IACtB;QACI,uBAAuB;QACvB,uBAAuB;QACvB,eAAe;QACf,mBAAmB;IACvB;;IAEA,8BAA8B;IAC9B;QACI,aAAa,EAAE,kDAAkD;IACrE;;IAEA,4BAA4B;IAC5B;QACI,uBAAuB;QACvB,4BAA4B;QAC5B,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA,iCAAiC;IACjC;QACI,0DAA0D;IAC9D;;IAEA,wCAAwC;IACxC;QACI,2BAA2B;QAC3B,wCAAwC;IAC5C;AACJ;;AAEA,gBAAgB;AAChB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA,gCAAgC;AAChC;IACI,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,+CAA+C;AACnD;;AAEA;;IAEI,aAAa;AACjB;;AAEA,2CAA2C;AAC3C;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,mCAAmC;AACnC;IACI;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;;QAEI,mCAAmC;IACvC;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;;QAEI,WAAW;QACX,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,6BAA6B;QAC7B,iCAAiC;QACjC,eAAe;IACnB;;IAEA,kCAAkC;IAClC;QACI,qBAAqB;IACzB;;IAEA;QACI,SAAS;IACb;;IAEA;;QAEI,sBAAsB;IAC1B;AACJ","sourcesContent":[".custom-table {\n    width: 100%;\n}\n  \n.list-group-item {\n    padding: 1rem 1rem;\n    border: 2.5px solid #f09502;\n    margin-top: 15px;\n    border-radius: 8px;\n    color: white;\n    background: transparent;\n    transition: all 0.3s ease;\n}\n\n.list-group-item:hover {\n    background: rgba(240, 149, 2, 0.1);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.column-tittle {\n    color: white !important;\n}\n\n.column-tittle div {\n    color: white !important;\n}\n\n/* Estilos para filtros */\n.card {\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(240, 149, 2, 0.3);\n    border-radius: 12px;\n}\n\n.card-header {\n    background: rgba(240, 149, 2, 0.2);\n    border-bottom: 1px solid rgba(240, 149, 2, 0.3);\n    color: white;\n}\n\n.form-control, .form-select {\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(240, 149, 2, 0.3);\n    color: white;\n    border-radius: 8px;\n}\n\n/* Estilos específicos para las opciones del select */\n.form-select option {\n    background-color: #2c2c2c !important;\n    color: white !important;\n    padding: 8px 12px;\n}\n\n.form-select option:hover {\n    background-color: #f09502 !important;\n    color: white !important;\n}\n\n.form-select option:checked {\n    background-color: #f09502 !important;\n    color: white !important;\n}\n\n/* Estilos para el dropdown cuando está abierto */\n.form-select:focus {\n    background: rgba(255, 255, 255, 0.15);\n    border-color: #f09502;\n    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);\n    color: white;\n}\n\n/* Estilos adicionales para compatibilidad con navegadores */\n.form-select option:not(:checked) {\n    background-color: #2c2c2c !important;\n    color: white !important;\n}\n\n/* Estilos para el contenedor del dropdown */\n.form-select {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n}\n\n/* Estilos para navegadores WebKit (Chrome, Safari, Edge) */\n.form-select::-webkit-list-button {\n    background-color: #2c2c2c;\n    color: white;\n}\n\n/* Estilos para Firefox */\n.form-select option {\n    background-color: #2c2c2c !important;\n    color: white !important;\n    border: none;\n}\n\n/* Estilos para el hover en las opciones */\n.form-select option:hover,\n.form-select option:focus {\n    background-color: #f09502 !important;\n    color: white !important;\n}\n\n.form-control:focus, .form-select:focus {\n    background: rgba(255, 255, 255, 0.15);\n    border-color: #f09502;\n    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);\n    color: white;\n}\n\n.form-control::placeholder {\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.form-label {\n    color: white;\n    font-weight: 500;\n    margin-bottom: 0.5rem;\n}\n\n/* Estilos para encabezados ordenables */\n.sortable-header {\n    cursor: pointer;\n    transition: color 0.3s ease;\n    display: inline-flex;\n    align-items: center;\n    user-select: none;\n}\n\n.sortable-header:hover {\n    color: #f09502 !important;\n}\n\n.sortable-header i {\n    transition: transform 0.3s ease;\n}\n\n.sortable-header:hover i {\n    transform: scale(1.1);\n}\n\n/* Estilos para badges */\n.badge {\n    font-size: 0.75rem;\n    padding: 0.5rem 0.75rem;\n    border-radius: 6px;\n}\n\n.badge.bg-primary {\n    background-color: #f09502 !important;\n}\n\n.badge.bg-success {\n    background-color: #28a745 !important;\n}\n\n.badge.bg-danger {\n    background-color: #dc3545 !important;\n}\n\n.badge.bg-warning {\n    background-color: #ffc107 !important;\n    color: #000;\n}\n\n/* Estilos para botones */\n.btn-sm {\n    padding: 0.375rem 0.75rem;\n    font-size: 0.875rem;\n    border-radius: 6px;\n    font-weight: 500;\n}\n\n.btn-success {\n    background-color: #28a745;\n    border-color: #28a745;\n}\n\n.btn-success:hover {\n    background-color: #218838;\n    border-color: #1e7e34;\n}\n\n.btn-danger {\n    background-color: #dc3545;\n    border-color: #dc3545;\n}\n\n.btn-danger:hover {\n    background-color: #c82333;\n    border-color: #bd2130;\n}\n\n.btn-outline-secondary {\n    color: #f09502;\n    border-color: #f09502;\n}\n\n.btn-outline-secondary:hover {\n    background-color: #f09502;\n    border-color: #f09502;\n    color: white;\n}\n\n.btn-outline-primary {\n    color: #f09502;\n    border-color: #f09502;\n}\n\n.btn-outline-primary:hover {\n    background-color: #f09502;\n    border-color: #f09502;\n    color: white;\n}\n\n/* Estilos para alertas */\n.alert-info {\n    background-color: rgba(23, 162, 184, 0.2);\n    border-color: rgba(23, 162, 184, 0.3);\n    color: white;\n}\n\n/* Estilos para estado vacío */\n.empty-state {\n    padding: 3rem 2rem;\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.05);\n    border: 2px dashed rgba(240, 149, 2, 0.3);\n}\n\n.empty-state i {\n    color: #f09502 !important;\n}\n\n.empty-state-icon {\n    font-size: 3rem !important;\n    color: #ccc !important;\n}\n\n.empty-state h4 {\n    color: white !important;\n}\n\n.empty-state p {\n    color: rgba(255, 255, 255, 0.7) !important;\n}\n\n/* Iconos */\n.bi {\n    font-size: 1rem;\n}\n\n.domo-color {\n    color: #f09502;\n}\n\n/* Estilos para fechas en desktop */\n.col-2 small {\n    color: white !important;\n    font-weight: 500;\n}\n\n.col-2 .bi {\n    color: #f09502;\n    margin-right: 0.25rem;\n}\n\n/* Espaciado general para pantallas medianas */\n@media (max-width: 1200px) and (min-width: 1025px) {\n    .list-group-item {\n        padding-left: 1.25rem;\n        padding-right: 1.25rem;\n    }\n}\n\n/* Layout tablets (iPad) - Vista horizontal de desktop pero con más espaciado */\n@media (max-width: 1024px) and (min-width: 769px) {\n    .list-group-item {\n        padding-left: 2rem;\n        padding-right: 2rem;\n    }\n    \n    .list-group-item .row .col-3,\n    .list-group-item .row .col-2 {\n        padding-left: 1rem;\n        padding-right: 1rem;\n    }\n    \n    /* Hacer botones un poco más grandes en tablet */\n    .btn-sm {\n        padding: 0.6rem 1.25rem;\n        font-size: 0.9rem;\n    }\n}\n\n/* Layout móvil mejorado */\n@media (max-width: 768px) {\n    .list-group-item {\n        padding: 1.25rem 0.5rem;\n        margin-bottom: 1rem;\n    }\n    \n    .list-group-item .row {\n        display: flex;\n        flex-direction: column;\n        gap: 0;\n    }\n    \n    /* Reorganizar layout para móvil */\n    .list-group-item .col-3,\n    .list-group-item .col-2 {\n        width: 100% !important;\n        max-width: 100% !important;\n        flex: 0 0 100% !important;\n        margin-bottom: 0;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0.75rem 1.5rem;\n        border-bottom: 1px solid rgba(240, 149, 2, 0.15);\n        min-height: 50px;\n    }\n    \n    .list-group-item .col-3:last-child,\n    .list-group-item .col-2:last-child {\n        border-bottom: none;\n    }\n    \n    /* Estructura común para todos los campos */\n    .list-group-item .col-3,\n    .list-group-item .col-2 {\n        position: relative;\n    }\n    \n    .list-group-item .col-3::before,\n    .list-group-item .col-2::before {\n        display: inline-block;\n        width: 30px;\n        text-align: center;\n        font-size: 1.1rem;\n        margin-right: 0.75rem;\n    }\n    \n    /* Email en móvil */\n    .list-group-item .col-3:first-child {\n        font-weight: 600;\n        font-size: 1rem;\n        padding-top: 0;\n    }\n    \n    .list-group-item .col-3:first-child::before {\n        content: \"📧\";\n    }\n    \n    .list-group-item .col-3:first-child .text-truncate {\n        flex: 1;\n        text-align: left;\n    }\n    \n    /* Monto en móvil */\n    .list-group-item .col-2:nth-child(2) {\n        align-items: center;\n    }\n    \n    .list-group-item .col-2:nth-child(2)::before {\n        content: \"💰\";\n    }\n    \n    .list-group-item .col-2:nth-child(2) .badge {\n        margin-left: auto;\n    }\n    \n    /* Fecha en móvil */\n    .list-group-item .col-2:nth-child(3) {\n        align-items: center;\n    }\n    \n    .list-group-item .col-2:nth-child(3)::before {\n        content: \"📅\";\n    }\n    \n    .list-group-item .col-2:nth-child(3) small {\n        margin-left: auto;\n        font-size: 0.9rem !important;\n        font-weight: 500 !important;\n    }\n    \n    /* Estado en móvil */\n    .list-group-item .col-2:nth-child(4) {\n        align-items: center;\n    }\n    \n    .list-group-item .col-2:nth-child(4)::before {\n        content: \"🏷️\";\n    }\n    \n    .list-group-item .col-2:nth-child(4) .badge {\n        margin-left: auto;\n    }\n    \n    /* Acciones en móvil */\n    .list-group-item .col-3:last-child {\n        justify-content: center;\n        padding: 1rem 1.5rem 0 1.5rem;\n        border-top: 1px solid rgba(240, 149, 2, 0.25);\n        border-bottom: none;\n        margin-top: 0.5rem;\n    }\n    \n    .list-group-item .col-3:last-child::before {\n        display: none;\n    }\n    \n    /* Headers ocultos en móvil */\n    .column-tittle {\n        display: none !important;\n    }\n    \n    /* Badges mejorados en móvil */\n    .badge {\n        font-size: 0.8rem !important;\n        padding: 0.5rem 0.75rem !important;\n        font-weight: 600 !important;\n        border-radius: 6px !important;\n        min-width: 80px;\n        text-align: center;\n    }\n    \n    /* Botones mejorados en móvil */\n    .btn-sm {\n        padding: 0.75rem 1.25rem;\n        font-size: 0.9rem;\n        margin: 0 0.375rem;\n        min-width: 120px;\n        font-weight: 600;\n        border-radius: 8px;\n        transition: all 0.3s ease;\n    }\n    \n    /* Flex para botones */\n    .d-flex.gap-2 {\n        gap: 0.75rem !important;\n        justify-content: center;\n        flex-wrap: wrap;\n        padding-top: 0.5rem;\n    }\n    \n    /* Iconos en elementos móvil */\n    .col-2 .bi {\n        display: none; /* Ocultar iconos bootstrap ya que usamos emojis */\n    }\n    \n    /* Texto mejorado en móvil */\n    .col-2 small {\n        color: white !important;\n        font-size: 0.9rem !important;\n        font-weight: 500 !important;\n        line-height: 1.2;\n    }\n    \n    /* Espaciado del email en móvil */\n    .list-group-item .col-3:first-child {\n        border-bottom: 1px solid rgba(240, 149, 2, 0.2) !important;\n    }\n    \n    /* Hover effects para botones en móvil */\n    .btn-sm:hover {\n        transform: translateY(-1px);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    }\n}\n\n/* Animaciones */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.list-group-item {\n    animation: fadeIn 0.3s ease-out;\n}\n\n/* Estilos para texto truncado */\n.text-truncate {\n    max-width: 200px;\n}\n\n/* Mejoras de accesibilidad */\n.btn:focus {\n    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.5);\n}\n\n.form-control:focus,\n.form-select:focus {\n    outline: none;\n}\n\n/* Estilos para el contador de resultados */\n.alert {\n    border-radius: 8px;\n    margin-bottom: 1.5rem;\n}\n\n/* Para dispositivos muy pequeños */\n@media (max-width: 480px) {\n    .list-group-item {\n        padding: 1rem 0.75rem;\n        margin: 0.75rem 0;\n    }\n    \n    .list-group-item .col-3,\n    .list-group-item .col-2 {\n        padding: 0.75rem 1.75rem !important;\n    }\n    \n    .list-group-item .col-3:last-child {\n        padding: 1rem 1.75rem 0 1.75rem !important;\n    }\n    \n    .list-group-item .col-3::before,\n    .list-group-item .col-2::before {\n        width: 25px;\n        font-size: 1rem;\n        margin-right: 0.5rem;\n    }\n    \n    .btn-sm {\n        padding: 0.65rem 1rem;\n        font-size: 0.85rem;\n        min-width: 110px;\n    }\n    \n    .badge {\n        font-size: 0.75rem !important;\n        padding: 0.4rem 0.6rem !important;\n        min-width: 70px;\n    }\n    \n    /* Panel de filtros más compacto */\n    .card-body {\n        padding: 1rem 0.75rem;\n    }\n    \n    .card-body .row.g-3 {\n        gap: 1rem;\n    }\n    \n    .card-body .col-md-3,\n    .card-body .col-md-6 {\n        margin-bottom: 0.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
